import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ContactForm.module.css";
import { Mail, Phone, Facebook, Twitter, Instagram } from "lucide-react";
import { useCreateContact } from "../../hooks/useContactUsHooks";

const ContactForm = () => {
  const navigate = useNavigate();
  
  // Social media URLs - hardcoded instead of using the missing useLinks hook
  const socialLinks = {
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    instagram: "https://instagram.com"
  };
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "General Inquiry",
    message: ""
  });
  
  const createContactMutation = useCreateContact();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    createContactMutation.mutate(formData, {
      onSuccess: () => {
        // Reset form after successful submission
        setFormData({
          name: "",
          email: "",
          subject: "General Inquiry",
          message: ""
        });
      }
    });
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], "_blank");
  };
  
  return (
    <div className={styles.container}>
      {/* Contact Form */}
      <div className={styles.formContainer}>
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <input 
            type="text" 
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your name" 
            required
          />
          
          <label>Email</label>
          <input 
            type="email" 
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@email.com" 
            required
          />
          
          <label>Subject</label>
          <select 
            name="subject"
            value={formData.subject}
            onChange={handleChange}
          >
            <option>General Inquiry</option>
            <option>Support</option>
            <option>Feedback</option>
          </select>
          
          <label>Message</label>
          <textarea 
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your message here..." 
            required
          />
          
          <button 
            type="submit" 
            disabled={createContactMutation.isLoading}
          >
            {createContactMutation.isLoading ? "Sending..." : "Send Message"}
          </button>
          
          {createContactMutation.isError && (
            <p className={styles.errorMessage}>
              Failed to send message. Please try again.
            </p>
          )}
        </form>
      </div>
      
      {/* Contact Info */}
      <div className={styles.infoContainer}>
        <div className={styles.contactInfo}>
          <h3>Contact Information</h3>
          <p><Mail size={24} className={styles.iconss} /> support@sunokahaniyan.com</p>
          <p><Phone size={24} className={styles.iconss} /> +91 (800) 123-4567</p>
        </div>
        
        {/* Social Media Links */}
        <div className={styles.socials} >
          <h3>Follow Us</h3>
          <div className={styles.icons}>
            <Facebook size={26} className={styles.iconss} onClick={() => handleSocialClick("facebook")} />
            <Twitter size={26} className={styles.iconss} onClick={() => handleSocialClick("twitter")} />
            <Instagram size={26} className={styles.iconss} onClick={() => handleSocialClick("instagram")} />
          </div>
        </div>
      </div>
    </div>
  );
};

// Separate Footer component
const Footer = () => {
  const navigate = useNavigate();
  
  // Social media URLs - hardcoded instead of using the missing useLinks hook
  const socialLinks = {
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    instagram: "https://instagram.com"
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], "_blank");
  };
  
  return (
    <footer className={styles.footer}>
      {/* Footer content here */}
    </footer>
  );
};

export default ContactForm;